import { OrderApiRoutes } from "../api";
export class OrderApi {
    constructor(api) {
        this.api = api;
    }
    api;
    sendOrder(mail) {
        return this.api.post(OrderApiRoutes.Create, mail);
    }
    createSubscription(request) {
        return this.api.post(OrderApiRoutes.Subscribe, request);
    }
}
